export const INACTIVE_BAR_COLOR = 'grey.300'
